// Single source of truth for the Settings sub-tabs. Consumed by both
// SettingsSideTabs (the nav) and SettingsPage (routing/redirects/width).

export type SettingsTabKey =
  | 'profile'
  | 'fund-profile'
  | 'team'
  | 'decision-rules'
  | 'integrations'
  | 'billing'
  | 'audit-log';

export interface SettingsTab {
  /** URL segment and i18n key suffix (settings.tabs.<key>). Also the icon key. */
  key: SettingsTabKey;
  /** Only visible/reachable by fund admins when true. */
  admin?: boolean;
  /** Content max-width modifier class (see settings.css .content--*). */
  contentClass: 'content--fund' | 'content--team' | 'content--integrations';
}

export const SETTINGS_TABS: readonly SettingsTab[] = [
  { key: 'profile', contentClass: 'content--fund' },
  { key: 'fund-profile', contentClass: 'content--fund' },
  { key: 'team', contentClass: 'content--team' },
  { key: 'decision-rules', admin: true, contentClass: 'content--fund' },
  { key: 'integrations', contentClass: 'content--integrations' },
  { key: 'billing', contentClass: 'content--fund' },
  { key: 'audit-log', contentClass: 'content--team' },
];

export const DEFAULT_SETTINGS_TAB: SettingsTabKey = 'profile';

export function findSettingsTab(key: string | undefined): SettingsTab | undefined {
  return SETTINGS_TABS.find(t => t.key === key);
}
